import React from 'react';
import Icons from '../svgs/icons';
import { MdEdit } from 'react-icons/md';
import { TutorialsPageData as pageData } from '../../utils/pageContent';

const FaqListItem = ({ data, index, onRemove, onEdit, disabled, title }) => {
  const sectionData = pageData.editTutorialPageData.tutorialInfoSection.faqFormSection;
  return (
    <div className="flex gap-4 items-center">
      {!disabled && (
        <button className="shrink-0" onClick={onRemove}>
          <Icons.minusCircle className="w-6 h-6 text-[#A1A1A1]" />
        </button>
      )}
      <div className="ml-1 border-[1.5px] shrink-0 border-shoorah-borderGray dark:border-transparent bg-shoorah-normanGray dark:bg-shoorah-darkBgColor rounded-[8px] px-[10px] py-2 text-sm font-medium">
        {title ? title : sectionData.faqTitleLabel} {index + 1}
      </div>
      {data.faqQuestion && (
        <p className="font-medium text-shoorah-lightBlack dark:text-white">{data.faqQuestion}</p>
      )}
      {!disabled && (
        <button className="" onClick={onEdit}>
          <MdEdit />
        </button>
      )}
    </div>
  );
};

export default FaqListItem;
